const CompanyManagement = () => {
  return <h1>Company management</h1>;
};

export default CompanyManagement;
